export const GRAPHS_EXTENDED_COLOR_PALETTE = [
  "#2e2d62",
  "#3d4469",
  "#315d90",
  "#3975a7",
  "#428ebd",
  "#4ca8d3",
  "#62c2cb",
  "#239498",
  "#115f69",
  "#5fa896",
  "#99d3ba",
  "#c1e7d2",
  "#FDEBC4",
  "#e6cd98",
  "#f1cd73",
  "#e89c1e",
  "#e5a85c",
  "#ed9054",
  "#f2784f",
  "#c85728",
  "#9a3811",
  "#f25e50",
  "#e84a5f",
  "#d63550",
  "#F1A49E",
  "#d980a3",
  "#B079A8",
  "#8a5d8f",
  "#5e3a6e",
  "#423258",
];
export const GRAPHS_CONTRAST_COLOR_PALETTE = [
  GRAPHS_EXTENDED_COLOR_PALETTE[0], // #2e2d62
  GRAPHS_EXTENDED_COLOR_PALETTE[2], // #315d90
  GRAPHS_EXTENDED_COLOR_PALETTE[7], // #239498
  GRAPHS_EXTENDED_COLOR_PALETTE[8], // #115f69
  GRAPHS_EXTENDED_COLOR_PALETTE[15], // #e89c1e
  GRAPHS_EXTENDED_COLOR_PALETTE[18], // #f2784f
  GRAPHS_EXTENDED_COLOR_PALETTE[20], // #9a3811
  GRAPHS_EXTENDED_COLOR_PALETTE[23], // #d63550
  GRAPHS_EXTENDED_COLOR_PALETTE[26], // #B079A8
  GRAPHS_EXTENDED_COLOR_PALETTE[29], // #423258
];
export const GRAPHS_GRADIENT_COLOR_PALETTE = [
  GRAPHS_EXTENDED_COLOR_PALETTE[1], // #3d4469
  GRAPHS_EXTENDED_COLOR_PALETTE[2], // #315d90
  GRAPHS_EXTENDED_COLOR_PALETTE[3], // #3975a7
  GRAPHS_EXTENDED_COLOR_PALETTE[4], // #428ebd
  GRAPHS_EXTENDED_COLOR_PALETTE[5], // #4ca8d3
  GRAPHS_EXTENDED_COLOR_PALETTE[16], // #e5a85c
  GRAPHS_EXTENDED_COLOR_PALETTE[17], // #ed9054
  GRAPHS_EXTENDED_COLOR_PALETTE[18], // #f2784f
  GRAPHS_EXTENDED_COLOR_PALETTE[21], // #f25e50
  GRAPHS_EXTENDED_COLOR_PALETTE[22], // #e84a5f
];
